import { render } from "./account-managment.vue?vue&type=template&id=18559050&ts=true"
import script from "./account-managment.vue?vue&type=script&lang=ts"
export * from "./account-managment.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\OnlinePayments\\OnlinePayments\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__